export default __webpack_public_path__ + "static/media/categoryType.ce675ca7.csv";